
















import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class TrackingOrderStatusSelect extends Vue {
  items = [
    'Unknown',
    'Intransit',
    'Undelivered',
    'Delivered',
    'Alert',
    'Notfound',
  ];
}
